import {Route, Routes, useLocation } from 'react-router-dom';
import {AnimatePresence} from 'framer-motion';
import Index from '../pages/Index';
import Login from '../pages/Login';
import NormalUser from '../pages/NormalUser';
import AdminUser from '../pages/AdminUser';
import SuperAdminUser from '../pages/SuperAdminUser';
import AdminConsole from '../pages/AdminConsole';
import SuperAdminConsole from '../pages/SuperAdminConsole';
import Modal from './shared/Modal';
import ModalMenu from './shared/ModalMenu';

function AnimatedRoutes() {
    const location = useLocation();

  return (
    <>
        <AnimatePresence mode='wait'>
            <Modal key='normalModal' />
            <ModalMenu key='modalMenu' />
            <Routes location={location} key={location.pathname}>
                <Route exact path='/' element={
                    <Index />
                }></Route>
                <Route path='/login' element={
                    <Login />
                }></Route>
                <Route path='/normal-user' element={
                    <NormalUser />
                }></Route>
                <Route path='/admin-user' element={
                    <AdminUser />
                }></Route>
                <Route path='/super-admin-user' element={
                    <SuperAdminUser
                     />
                }></Route>
                <Route path='/admin-console' element={
                    <AdminConsole />
                }></Route>
                <Route path='/super-admin-console' element={
                    <SuperAdminConsole />
                }></Route>
            </Routes>
        </AnimatePresence>
    </>
  )
}

export default AnimatedRoutes;